"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resolveImageUrl = exports.resolveImage = exports.resolveThumbnailImage = exports.findFlexSpotExternalBannerData = exports.preProcessForFilters = exports.pepSkeletonLoader = exports.checkIfLifestyleImg = exports.dotsBackgroundColor = exports.toggleLayerFunction = exports.createActiveFilters = exports.checkIsMobile = exports.getProductId = exports.importerExternalScripts = exports.getDictionaryItems = exports.sessionStorageFactory = exports.getSettings = exports.getGuideDevices = exports.getSitecoreData = exports.getRelatedAccessoriesWithSettings = exports.getProductListWithSettings = exports.getAccessoriesListWithSettings = exports.getProductDetails = exports.getProductDetailsWithSettings = exports.getCatalog = exports.sendCustomGA4DataLayerEvent = exports.sendGA4DataLayerEvent = exports.sendDataLayerEvent = exports.findAvaliableHtmlComponent = exports.sendGA4Event = exports.sendCustomGA4Event = exports.sendCustomEvent = exports.isDataLayer = exports.getHearingLossSeverrity = exports.EXLUDED_FILTER_ENGLISH_LABEL = void 0;

var _react = _interopRequireDefault(require("react"));

var _pim = require("@demant/pim");

var _constans = require("./constans");

var _index = require("../../index");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var EXLUDED_FILTER_ENGLISH_LABEL = 'Moderately Severe';
exports.EXLUDED_FILTER_ENGLISH_LABEL = EXLUDED_FILTER_ENGLISH_LABEL;

var getHearingLossSeverrity = function getHearingLossSeverrity(masterArray, localArray) {
  if (!masterArray || !localArray) {
    return null;
  }

  var indexToRemove = masterArray.findIndex(function (item) {
    return item.toLowerCase() === EXLUDED_FILTER_ENGLISH_LABEL.toLowerCase();
  });

  if (indexToRemove > -1) {
    var newArray = _toConsumableArray(localArray);

    newArray.splice(indexToRemove, 1);
    return newArray;
  } else {
    return localArray;
  }
};

exports.getHearingLossSeverrity = getHearingLossSeverrity;

var isDataLayer = function isDataLayer() {
  return window.DGS && window.DGS.GTMTracking && window.DGS.GTMTracking.getDataLayer().length;
};

exports.isDataLayer = isDataLayer;

var sendCustomEvent = function sendCustomEvent(eventAction, eventLabel, element) {
  return {
    event: 'GAevent',
    eventCategory: 'PEP',
    eventAction: eventAction,
    eventLabel: eventLabel,
    eventCallback: function eventCallback(gtm) {
      if (element && gtm === 'GTM-NSW8N73') {
        window.open(element.href, element.target ? element.target : '_self');
      }
    }
  };
};

exports.sendCustomEvent = sendCustomEvent;

var sendCustomGA4Event = function sendCustomGA4Event(eventAction, eventLabel, eventType, eventHLS, eventFunctionalities, eventDesignedFor) {
  return {
    event: 'genericGAEvent',
    event_category: 'product_click',
    event_action: eventAction,
    event_label: eventLabel,
    event_type: eventType,
    event_hls: eventHLS,
    event_functionalities: eventFunctionalities,
    event_designed_for: eventDesignedFor
  };
};

exports.sendCustomGA4Event = sendCustomGA4Event;

var sendGA4Event = function sendGA4Event(event, eventCategory, eventAction, eventLabel, eventValue) {
  return {
    event: event,
    event_category: eventCategory,
    event_action: eventAction,
    event_label: eventLabel,
    event_value: eventValue
  };
};

exports.sendGA4Event = sendGA4Event;

var findAvaliableHtmlComponent = function findAvaliableHtmlComponent() {
  var htmlPepComponents = [".".concat(_constans.initialState.pepListComponentName), ".".concat(_constans.initialState.pepDetailsComponentName), ".".concat(_constans.initialState.pepAccListComponentName)];
  var currentComponent = htmlPepComponents.filter(function (element) {
    return document.querySelector(element);
  });
  return currentComponent[0];
};

exports.findAvaliableHtmlComponent = findAvaliableHtmlComponent;

var sendDataLayerEvent = function sendDataLayerEvent(action, label, element) {
  if (isDataLayer()) {
    if (element) {
      element.preventDefault();
    }

    window.DGS.GTMTracking.getDataLayer().push(sendCustomEvent(action, label, element && element.currentTarget ? element.currentTarget : null));
  }
};

exports.sendDataLayerEvent = sendDataLayerEvent;

var sendGA4DataLayerEvent = function sendGA4DataLayerEvent(event, category, action, label, value) {
  if (isDataLayer()) {
    window.DGS.GTMTracking.getDataLayer().push(sendGA4Event(event, category, action, label, value));
  }
};

exports.sendGA4DataLayerEvent = sendGA4DataLayerEvent;

var sendCustomGA4DataLayerEvent = function sendCustomGA4DataLayerEvent(action, label, type, hls, functionalities, designedFor) {
  if (isDataLayer()) {
    window.DGS.GTMTracking.getDataLayer().push(sendCustomGA4Event(action, label, type, hls, functionalities, designedFor));
  }
};

exports.sendCustomGA4DataLayerEvent = sendCustomGA4DataLayerEvent;

var getCatalog = function getCatalog() {
  var componentWithCatalog = document.querySelector('.component[data-catalogid]');

  if (componentWithCatalog) {
    return document.querySelector('.component[data-catalogid]').getAttribute('data-catalogid');
  }

  var pimApi = new _pim.PIM();
  return pimApi.getCatalogID('PEP').then(function (catalogId) {
    return catalogId;
  })["catch"](function (reason) {
    console.log(reason);
  });
};

exports.getCatalog = getCatalog;

var getToken = function getToken() {
  var pimApi = new _pim.PIM();
  return pimApi.getToken('PEP', true).then(function (token) {
    return token;
  })["catch"](function (reason) {
    console.log(reason);
  });
};

var getCultureCode = function getCultureCode() {
  if (document.querySelector('.component[data-culture]')) {
    return document.querySelector('.component[data-culture]').getAttribute('data-culture');
  }

  var pimApi = new _pim.PIM();
  return pimApi.getCulture('PEP').then(function (culture) {
    return culture;
  })["catch"](function (reason) {
    console.log(reason);
  });
};

var getProductDetailsWithSettings = function getProductDetailsWithSettings(params, token) {
  var pimApi = new _pim.PIM();
  return pimApi.fetchPEPOnlyProductDetails(params, token).then(function (product) {
    return product;
  })["catch"](function (reason) {
    console.log(reason);
  });
};

exports.getProductDetailsWithSettings = getProductDetailsWithSettings;

var getProductDetails = function getProductDetails(params) {
  var pimApi = new _pim.PIM();
  return pimApi.getPEPProductDetails(params).then(function (product) {
    return product;
  })["catch"](function (reason) {
    console.log(reason);
  });
};

exports.getProductDetails = getProductDetails;

var getAccessoriesListWithSettings = function getAccessoriesListWithSettings(params, token) {
  var pimApi = new _pim.PIM();
  return pimApi.fetchPEPOnlyAccessories(params, token).then(function (products) {
    return products;
  })["catch"](function (reason) {
    console.log(reason);
  });
};

exports.getAccessoriesListWithSettings = getAccessoriesListWithSettings;

var getProductListWithSettings = function getProductListWithSettings(params, token, isAccessoriesList) {
  var pimApi = new _pim.PIM();

  if (!isAccessoriesList) {
    return pimApi.fetchPEPOnlyBrowseHearingAids(params, token).then(function (products) {
      return (// additional logic for products which comes from PIM, for instance new field productBrandAndFamily, telecoil and bluetooth logic
        // preProcessForFilters(products.hearingAids);
        products
      );
    })["catch"](function (reason) {
      console.log(reason);
    });
  }

  return pimApi.fetchPEPOnlyAccessories(params, token).then(function (products) {
    return products;
  })["catch"](function (reason) {
    console.log(reason);
  });
};

exports.getProductListWithSettings = getProductListWithSettings;

var getRelatedAccessoriesWithSettings = function getRelatedAccessoriesWithSettings(params, token) {
  var pimApi = new _pim.PIM();
  return pimApi.fetchPEPOnlyRelatedAccessories(params, token).then(function (relatedProducts) {
    return relatedProducts;
  })["catch"](function (reason) {
    console.log(reason);
  });
};

exports.getRelatedAccessoriesWithSettings = getRelatedAccessoriesWithSettings;

var getSitecoreData = function getSitecoreData(directPimData, isAccessoriesList) {
  var PEPComponent = new _index.PEPHearingInstrumentList(!isAccessoriesList ? _constans.initialState.pepListComponentName : _constans.initialState.pepAccListComponentName, directPimData);
  return PEPComponent;
};

exports.getSitecoreData = getSitecoreData;

var getGuideDevices = function getGuideDevices(params) {
  var pimApi = new _pim.PIM();
  return pimApi.getCompatibilityGuideDevices({
    ProductId: params.ProductId
  });
};

exports.getGuideDevices = getGuideDevices;

var getSettings = function getSettings() {
  return Promise.all([getCatalog(), getCultureCode(), getToken()]).then(function (data) {
    return {
      params: {
        catalogId: data[0],
        Culture: data[1],
        isReady: true
      },
      token: _objectSpread({}, data[2])
    };
  });
};

exports.getSettings = getSettings;

var sessionStorageFactory = function sessionStorageFactory(action, name, data) {
  switch (action) {
    case 'setItem':
      window.sessionStorage.setItem(name, JSON.stringify(data));
      return JSON.parse(sessionStorage.getItem(name));

    case 'getItem':
      return JSON.parse(sessionStorage.getItem(name));

    case 'checkStorageItem':
      return sessionStorage.getItem(name);

    case 'checkLength':
      return sessionStorageFactory('checkStorageItem', name) ? Object.keys(JSON.parse(sessionStorage.getItem(name))).length || JSON.parse(sessionStorage.getItem(name)).length : 0;

    default:
      return false;
  }
};

exports.sessionStorageFactory = sessionStorageFactory;

var getDictionaryItems = function getDictionaryItems(component) {
  findAvaliableHtmlComponent();
  var dictionary = _constans.initialDictionary;
  var labels = {};
  var $dictionary = Array.from(component.querySelectorAll('.dictionary *'));
  $dictionary.forEach(function (item) {
    labels[item.getAttribute('class')] = item.textContent;
  });
  var isProfessional = window.location.href.indexOf("/".concat(_constans.initialState.professionalKey.toLowerCase())) > 1;
  var newDictionary = {};
  Object.keys(dictionary).map(function (val) {
    var professionalKey = val + _constans.initialState.professionalKey;
    var key = isProfessional && labels[professionalKey] ? professionalKey : val;

    if (_typeof(dictionary[key]) !== 'object') {
      return labels[key] ? newDictionary[val] = labels[key] : newDictionary[val] = dictionary[key];
    }

    return newDictionary[val] = dictionary[key];
  });
  return newDictionary;
};

exports.getDictionaryItems = getDictionaryItems;
var importerExternalScripts = {
  url: function url(_url) {
    return new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = _url;
      script.addEventListener('load', function () {
        return resolve(script);
      }, false);
      script.addEventListener('error', function () {
        return reject(script);
      }, false);
      document.body.appendChild(script);
    });
  },
  urls: function urls(_urls) {
    return Promise.all(_urls.map(importerExternalScripts.url));
  }
};
exports.importerExternalScripts = importerExternalScripts;

var getProductId = function getProductId(prod) {
  return prod.productId;
};

exports.getProductId = getProductId;

var checkIsMobile = function checkIsMobile() {
  return window.innerWidth < parseFloat(_constans.initialDictionary.mobileBreakpoint);
};

exports.checkIsMobile = checkIsMobile;

var createActiveFilters = function createActiveFilters(filters) {
  var activeFiltersLabel = [];
  Object.keys(filters).forEach(function (filterValue) {
    filters[filterValue].values.forEach(function (label) {
      activeFiltersLabel.push({
        value: label,
        dataKey: filterValue
      });
    });
  });
  return activeFiltersLabel;
};

exports.createActiveFilters = createActiveFilters;

var toggleLayerFunction = function toggleLayerFunction(isOpen, customClass) {
  customClass = customClass || 'block-scroll';
  isOpen ? document.querySelector('body').classList.add(customClass) : document.querySelector('body').classList.remove(customClass);
  return isOpen;
};

exports.toggleLayerFunction = toggleLayerFunction;

var dotsBackgroundColor = function dotsBackgroundColor(color) {
  if (color.colorRGB && color.colorRGB != null && color.secondaryColorRGB) {
    return "linear-gradient(to right, ".concat(color.colorRGB, " 50%, ").concat(color.secondaryColorRGB, " 50%)");
  }

  return color.colorRGB || color.secondaryColorRGB;
};

exports.dotsBackgroundColor = dotsBackgroundColor;

var checkIfLifestyleImg = function checkIfLifestyleImg(imgUrl) {
  return imgUrl.includes('Still_Life') || imgUrl.includes('Still_life');
};

exports.checkIfLifestyleImg = checkIfLifestyleImg;

var pepSkeletonLoader = function pepSkeletonLoader(state, selector) {
  var FETCHED_CLASS = 'fetched';

  if (!document.querySelector('.skeleton-fake-list')) {
    var defaultSelector = selector || _constans.initialState.pepListComponentName;
    var $element = document.querySelector(".".concat(defaultSelector)) ? document.querySelector(".".concat(defaultSelector)) : document.querySelector(".".concat(_constans.initialState.pepDetailsComponentName, ", .").concat(_constans.initialState.pepAccListComponentName));

    if (state === 'init') {
      $element === null || $element === void 0 ? void 0 : $element.classList.remove(FETCHED_CLASS);
    } else if (!($element !== null && $element !== void 0 && $element.classList.contains(FETCHED_CLASS))) {
      setTimeout(function () {
        $element === null || $element === void 0 ? void 0 : $element.classList.add(FETCHED_CLASS);
      }, 100);
    }
  }
};

exports.pepSkeletonLoader = pepSkeletonLoader;

var preProcessForFilters = function preProcessForFilters(products) {
  products.map(function (product) {
    if (product !== null && product !== void 0 && product.productBrand && product.productFamily) {
      product.productBrandAndFamily = "".concat(product.productBrand, " ").concat(product.productFamily);
    }

    if ((product === null || product === void 0 ? void 0 : product.bluetooth) === null && (product === null || product === void 0 ? void 0 : product.telecoil) === null) {
      product.bluetooth = true;
      product.telecoil = true;
    }

    if ((product === null || product === void 0 ? void 0 : product.rechargeability) === null) {
      product.rechargeability = false;
    }
  });
  return products;
};

exports.preProcessForFilters = preProcessForFilters;

var findFlexSpotExternalBannerData = function findFlexSpotExternalBannerData() {
  var PRODCT_LIST_BANNERS_CLASS = ".flex-spot.product-list-banners";
  var $banners = document.querySelector(PRODCT_LIST_BANNERS_CLASS);
  var elements = [];

  if ($banners) {
    var elementsList = $banners.querySelectorAll(".element");
    var parsedToArray = Array.from(elementsList) || null;
    parsedToArray === null || parsedToArray === void 0 ? void 0 : parsedToArray.filter(function (element) {
      var _element$querySelecto, _element$querySelecto2;

      var img = element.querySelector(".element__item__image img");
      elements.push({
        tag: element.getAttribute("data-tag"),
        imageSrc: (img === null || img === void 0 ? void 0 : img.getAttribute("data-src")) || (img === null || img === void 0 ? void 0 : img.getAttribute("src")) || "",
        html: ((_element$querySelecto = element.querySelector(".element__item__text")) === null || _element$querySelecto === void 0 ? void 0 : _element$querySelecto.outerHTML) || "",
        link: ((_element$querySelecto2 = element.querySelector(".element__item__link a")) === null || _element$querySelecto2 === void 0 ? void 0 : _element$querySelecto2.getAttribute("href")) || ""
      });
    });
  }

  return elements.length > 0 ? elements : null;
};

exports.findFlexSpotExternalBannerData = findFlexSpotExternalBannerData;

var buildCompressionQuery = function buildCompressionQuery(query) {
  return "?".concat(_constans.fastlyCompressionQuery.general).concat(query ? '&' + query : '');
};

var resolveThumbnailImage = function resolveThumbnailImage(imageObject, query) {
  if (imageObject) {
    return isCdnUrl(imageObject) ? String(imageObject.cdnUrl + buildCompressionQuery(query)) : (imageObject === null || imageObject === void 0 ? void 0 : imageObject.thumbnailUrl) || '';
  } else {
    return '';
  }
};

exports.resolveThumbnailImage = resolveThumbnailImage;

var isCdnUrl = function isCdnUrl(file) {
  return !!file.cdnUrl;
};

var resolveImage = function resolveImage(imageObject, query) {
  if (imageObject) {
    return isCdnUrl(imageObject) ? String(imageObject.cdnUrl + buildCompressionQuery(query)) : (imageObject === null || imageObject === void 0 ? void 0 : imageObject.fileUrl) || '';
  } else {
    return '';
  }
};

exports.resolveImage = resolveImage;

var resolveImageUrl = function resolveImageUrl(imageObject, query) {
  if (imageObject) {
    return isCdnUrl(imageObject) ? String(imageObject.cdnUrl + buildCompressionQuery(query)) : (imageObject === null || imageObject === void 0 ? void 0 : imageObject.url) || '';
  } else {
    return '';
  }
};

exports.resolveImageUrl = resolveImageUrl;